import { supabase } from './api'

export const revalidate = 0

export async function getAllData() {
	const { data, error } = await supabase.from('resourcecenter').select()

	if (error) {
		throw new Error(`Failed to fetch resource data: ${error.message}`)
	}
	return data
}

export async function getIdData(id) {
	const { data, error } = await supabase.from('resourcecenter').select().eq('id', id)

	if (error) {
		throw new Error(`Failed to fetch resource data: ${error.message}`)
	}

	return data
}

export async function addData(adata) {
	const { data, error } = await supabase.from('resourcecenter').insert(adata).select()

	if (error) {
		throw new Error(`Failed to add resource: ${error.message}`)
	}

	return data
}

export async function updateData(udata) {
	const { data, error } = await supabase.from('resourcecenter').update(udata).eq('id', udata.id).select()

	if (error) {
		throw new Error(`Failed to update resource: ${error.message}`)
	}

	return data
}

export async function deleteIdData(id) {
	const { data, error } = await supabase.from('resourcecenter').delete().eq('id', id)

	if (error) {
		throw new Error(`Failed to delete resource: ${error.message}`)
	}

	return data
}
